import React from 'react';
import { injectIntl } from 'react-intl';

import FormAutocomplete from 'components/forms/FormAutocomplete';

class CmsTextColorSelector extends React.Component {
  render() {
    const { type, label, getParamValue, setParam } = this.props;

    const options = [
      'master',
      'black',
      'white',
      'complete',
      'success',
      'info',
      'warning',
      'warning-dark',
      'danger',
      'primary',
    ];

    return (
      <FormAutocomplete
        onChange={setParam}
        value={getParamValue(type)}
        label={label}
        name={type}
        options={options.map(option => {
          return { label: option, value: option };
        })}
      />
    );
  }
}
CmsTextColorSelector.defaultProps = {
  type: 'mainColor',
};

export default injectIntl(CmsTextColorSelector);
